module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('div', [_c('loader')], 1) : _c('div', [_c('div', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Nome")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newSection.name),
      expression: "newSection.name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "name",
      "placeholder": "Nome"
    },
    domProps: {
      "value": (_vm.newSection.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newSection, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "description"
    }
  }, [_vm._v("Descrição")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newSection.description),
      expression: "newSection.description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "description",
      "placeholder": "Descrição"
    },
    domProps: {
      "value": (_vm.newSection.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newSection, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "description"
    }
  }, [_vm._v("Repetição")]), _vm._v(" "), _c('p', {
    staticClass: "help-block"
  }, [_vm._v("A seção pode se repetir?")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newSection.repeat.active),
      expression: "newSection.repeat.active"
    }],
    attrs: {
      "id": "repeat",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.newSection.repeat.active) ? _vm._i(_vm.newSection.repeat.active, null) > -1 : (_vm.newSection.repeat.active)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.newSection.repeat.active,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.newSection.repeat, "active", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.newSection.repeat, "active", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.newSection.repeat, "active", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newSection.repeat.active),
      expression: "newSection.repeat.active"
    }]
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "repeatMin"
    }
  }, [_vm._v("Mínimo")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newSection.repeat.min),
      expression: "newSection.repeat.min"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "repeatMin",
      "type": "number"
    },
    domProps: {
      "value": (_vm.newSection.repeat.min)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newSection.repeat, "min", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "repeatMax"
    }
  }, [_vm._v("Máximo")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newSection.repeat.max),
      expression: "newSection.repeat.max"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "repeatMax",
      "type": "number"
    },
    domProps: {
      "value": (_vm.newSection.repeat.max)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newSection.repeat, "max", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "description"
    }
  }, [_vm._v("Ação")]), _vm._v(" "), _c('p', {
    staticClass: "help-block"
  }, [_vm._v("Ação ao submeter dados da seção:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newSection.action),
      expression: "newSection.action"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "type",
      "placeholder": "Comportamento"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newSection, "action", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.sectionActions), function(sectionAction) {
    return _c('option', {
      key: sectionAction.objectId,
      domProps: {
        "value": sectionAction
      }
    }, [_vm._v(_vm._s(sectionAction))])
  }), 0)]), _vm._v(" "), (_vm.newSection.action === 'goto') ? _c('div', {
    staticClass: "form-group"
  }, [_c('multiselect', {
    attrs: {
      "label": "name",
      "track-by": "objectId",
      "options": _vm.sections,
      "showLabels": false,
      "placeholder": "Selecione uma opção"
    },
    model: {
      value: (_vm.newSection.goto),
      callback: function($$v) {
        _vm.$set(_vm.newSection, "goto", $$v)
      },
      expression: "newSection.goto"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "id": "btn-save-field",
      "type": "button"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Salvar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancelar")])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.requestTypeId && _vm.sectionId) ? _c('form-field-list', {
    attrs: {
      "reqType": _vm.requestTypeId,
      "sectionId": _vm.sectionId
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a7ebd626"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FormSectionDetail.vue
// module id = 1465
// module chunks = 1